import script from "./PzwhChatDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PzwhChatDialog.vue?vue&type=script&setup=true&lang=js"

import "./PzwhChatDialog.vue?vue&type=style&index=0&id=e83778b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e83778b4"]])

export default __exports__